import React, { Component } from 'react'
// import {firebase, googleAuth} from '../../firebase';

export default class AdminHeader extends Component {

    render() {
        return (
            <div>
                <hr className="my-2" />
                <h2>Admin Header</h2>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/header/adminheader.js